import React from 'react';
import { Link } from 'react-router-dom';
import MarketingHeader from '../../components/MarketingHeader';
import { useScheduleSocialPost, useSocialCalendarPosts } from '../../hooks/useSocial';
import { SecondaryButton } from '../../styles/marketingSharedStyles';
import { Card, CardTitle, Input, Item, List, Page, Row, Subtle } from './socialStyles';

const SocialCalendarPage: React.FC = () => {
  const calendar = useSocialCalendarPosts();
  const schedulePost = useScheduleSocialPost();

  const onReschedule = async (postId: string, nextIsoLocal: string) => {
    if (!nextIsoLocal) return;
    await schedulePost.mutateAsync({ postId, scheduledFor: new Date(nextIsoLocal).toISOString() });
  };

  return (
    <Page>
      <MarketingHeader activeTab="social" />

      <Card>
        <CardTitle>Content Calendar</CardTitle>
        <Subtle>Scheduled, publishing, published, and failed posts.</Subtle>
      </Card>

      <Card>
        {calendar.isLoading ? (
          <Subtle>Loading scheduled content...</Subtle>
        ) : (
          <List>
            {(calendar.data ?? []).map((post) => {
              let nextLocal = '';
              if (post.scheduled_for) {
                const date = new Date(post.scheduled_for);
                const tz = date.getTimezoneOffset() * 60_000;
                nextLocal = new Date(date.getTime() - tz).toISOString().slice(0, 16);
              }

              return (
                <Item key={post.id}>
                  <Row>
                    <strong>{post.title || 'Untitled Post'}</strong>
                    <span>{post.workflow_status}</span>
                    <span>{post.scheduled_for ? new Date(post.scheduled_for).toLocaleString() : 'No schedule'}</span>
                    <Input
                      type="datetime-local"
                      defaultValue={nextLocal}
                      onBlur={(event) => onReschedule(post.id, event.target.value)}
                    />
                    <SecondaryButton type="button" onClick={() => onReschedule(post.id, nextLocal)}>
                      Update Schedule
                    </SecondaryButton>
                    <Link to={`/marketing/social/composer/${post.id}`}>Edit</Link>
                  </Row>
                </Item>
              );
            })}
            {(calendar.data ?? []).length === 0 ? <Subtle>No scheduled social content yet.</Subtle> : null}
          </List>
        )}
      </Card>
    </Page>
  );
};

export default SocialCalendarPage;
